import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const TransactionWallet = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="15" viewBox="-2 -2 17 19" fill="none">
    <g clipPath="url(#clip0_758_1447)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3335 3.72076L5.64973 1.82617C5.0022 1.61032 4.3335 2.09229 4.3335 2.77485V4.33333L11.3335 6.66667V3.72076ZM11.3335 7.72076L4.3335 5.38743V10.5585C4.3335 10.9889 4.60893 11.371 5.01727 11.5072L11.3335 13.6126V7.72076ZM12.3335 3.72076V7V15H11.3335H2.3335C1.22893 15 0.333496 14.1046 0.333496 13V8V7V5C0.333496 3.89543 1.22893 3 2.3335 3H3.3335V2.77485C3.3335 1.40973 4.67089 0.445795 5.96596 0.877482L11.6497 2.77207C12.0581 2.90819 12.3335 3.29033 12.3335 3.72076ZM9.33351 14L4.70104 12.4558C3.88436 12.1836 3.3335 11.4193 3.3335 10.5585V8H1.3335V13C1.3335 13.5523 1.78122 14 2.3335 14H9.33351ZM3.3335 7V4H2.3335C1.78122 4 1.3335 4.44772 1.3335 5V7H3.3335Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_758_1447">
        <rect width="12" height="15" fill="white" transform="translate(0.333496)" />
      </clipPath>
    </defs>
  </svg>,
  'TransactionWallet'
);
